module.exports = __webpack_public_path__ + "static/img/电力电网.6bf33d1c.jpeg";